import Service from "../../Service";

const resource = "HmnPublicRecruitmentInvitation/";

export default {
  save(item, requestID) {
    return Service.post(resource + "save", item, {
      params: { requestID: requestID },
    });
  },
  sendEmailInvitations(payload, requestID) {
    return Service.post(resource + "send-email-invitations", payload, {
      params: { requestID: requestID },
    });
  },
  getInvitationAssets(requestID) {
    return Service.post(resource + "invitation-assets", null, {
      params: { requestID: requestID },
    });
  },
};
